import { Component, EventEmitter, Input, OnChanges, OnInit, Output, SimpleChanges, ViewChild } from '@angular/core';
import { DxButtonModule, DxTextBoxModule, DxPopupModule, DxScrollViewModule, DxToastModule } from 'devextreme-angular';
import { CtlTmsAmbarAramaComponent } from './ctl-tms-ambar-arama/ctl-tms-ambar-arama.component';
import { TmsAmbarService} from './ctl-tms-ambar.service';
import { CommonModule } from '@angular/common';
import { CtlSablonComponent } from '../ctl-sablon/ctl-sablon.component';
import { LabelMode } from 'devextreme/common';
import { UtilsService } from '../../../services/utils.service';
import { OrtakService } from '../../../services/ortak.service';
import {alert} from "devextreme/ui/dialog";
import {ControlConditionModel} from "../../../models/gen-control.model";

@Component({
  selector: 'dk-ctl-tms-ambar',
  standalone: true,
  imports: [
    DxTextBoxModule,
    DxButtonModule,
    CtlTmsAmbarAramaComponent,
    CommonModule,
    DxPopupModule,
    DxScrollViewModule,
    CtlSablonComponent,
    DxToastModule
  ],
  providers: [TmsAmbarService],
  templateUrl: './ctl-tms-ambar.component.html',
  styleUrls: ['./ctl-tms-ambar.component.scss'],
})
export class CtlTmsAmbarComponent implements OnInit, OnChanges {
  @ViewChild(CtlSablonComponent) ctlSablonComponent: CtlSablonComponent;
  @Input() labelText = "";
  @Input() labelMode:LabelMode = null;
  public crudPopupVisible = false;
  public title!: string;
public isFirst = true;
  public control!: any;
  controlName = "TmsAmbar";
  @Input() isReadOnly = false;
  @Input() isBindCheck = false;
  public toastMessage: string;
  public toastVisible = false;
  public showAction = true;
  public data: any;
  @Input() yetkiKontrol: boolean=false;
  @Input() code: any;
  @Input() validationRulesMap!:any[];
  @Input() validationV2 = false;
  @Input() controlCondition: ControlConditionModel[];
  @Input() warningMessage: string | null = null;
  @Output() public dataResult: EventEmitter<any> = new EventEmitter();

  constructor(private service: TmsAmbarService, private utilsService: UtilsService, private ortakService: OrtakService) {}

  ngOnInit(): void {
    if (this.controlName) {
      this.getControl();
    }
    this.setParams();
  }

  ngOnChanges(changes: SimpleChanges) {
    this.showAction = true
    if (changes['code']) {
      this.getData(this.code, false, this.yetkiKontrol)
    }
    if (changes && (changes['controlCondition'])) {
      this.setParams();
    }
    if (changes['isReadOnly'] || changes['isBindCheck']) {
    this.service.setParams(this.yetkiKontrol,this.isReadOnly,this.isBindCheck);
      }
    // if (changes['yetkiKontrol']) {
    //   this.getData(this.code,false, this.yetkiKontrol)
    // }
  }

  setParams(){
    this.service.setParams(this.yetkiKontrol,this.isReadOnly,this.isBindCheck);
    this.service.controlCondition = this.controlCondition;
  }

  getControl(){
    this.ortakService.getControl(this.controlName)
    .subscribe((data) => {
      this.control = data?.controlMetadata;
             //this.service.getDlist(this.control?.dlistCode);
      this.service._gridControlsList.next(data?.controlMetadata?.dlistMetadata)
      //if(this.labelText === "")this.labelText = this.control.controlDescription;
        if(data?.controlMetadata?.dlistMetadata?.baseEntity){
          if(this.labelText === "")this.labelText = this.control?.controlDescription;
          if(this.code && this.control) this.getData(this.code,true, this.yetkiKontrol)
          if(this.isFirst) this.isFirst = false;
        }
    });
  }



  searchClick() {
    if(this.showAction) this.crudPopupVisible = true
    else this.toastVisible = true
  }

  clear() {
    this.title = '';
    this.code = '';
    this.data = null;
    this.dataResult.emit(null);
  }

  handleValueChange(e: any) {
    if(this.showAction){
      if (e === '' || e === null) this.clear();
      else if(!this.isFirst) this.getData(e, false, this.yetkiKontrol);
    this.isFirst = false;
    }
    else this.toastVisible = true
  }

  getData(code: any, isSetData?: boolean, yetkiKontrol?:boolean) {


      this.data = this.service.getData(Number(code),this.control,this.control?.dlistMetadata?.baseEntity,isSetData, yetkiKontrol);
      if(this.data){
        this.data.load().done((result: any) => {
          //this.clear();
          if ((result.length > 0)) {
            if (result[0].AktifEh==='H') alert(`Seçtiğiniz ${result[0].Kod} nolu ambar aktif değildir!`, 'Uyarı!')
            this.title = result[0].Ad;
            this.code = result[0].Kod;
            this.dataResult.emit(result[0]);
          } else if (this.code.length > 0) {
            this.utilsService.showError('Bulunamadı');
            this.clear();
          }

        });
      }
  }

  closePopupAfter(result: any, sablonCmp: CtlSablonComponent) {
    if (result?.data) {
      this.isFirst=true
      this.title = result.data.Ad;
      this.data = result.data;
      this.code = result.data.Kod;
      this.dataResult.emit(this.data);
    }
    this.crudPopupVisible = false;
    setTimeout(() => {
      sablonCmp.focusInput();
    });
  }
}

